import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export const AssetHealth = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/system/assets").then((r) => setS(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!s || s.ok) return null;
  return (
    <div className="border border-red-300 bg-red-50 text-red-900 p-5 mb-6 flex gap-4" role="alert" data-testid="asset-health-warning">
      <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
      <div>
        <p className="font-semibold">Builds are paused: {s.missing.length} file{s.missing.length > 1 ? "s" : ""} the PDFs and posts need {s.missing.length > 1 ? "are" : "is"} missing</p>
        <p className="text-sm mt-1" data-testid="asset-health-missing">{s.missing.join(", ")}</p>
        <p className="text-sm mt-2">New guides, updates, relocation builds, comparisons and Instagram posts wait until these are restored, so nothing goes out with the wrong fonts. Ask the builder to restore them, or roll back to a version where they existed.</p>
      </div>
    </div>
  );
};
